export default "__VITE_ASSET__CFOh016K__"